module.exports = __webpack_public_path__ + "img/glass_non_laminated.79fe9f5.svg";